export default "__VITE_ASSET__sJiKMlyb__"